import React, { useContext } from 'react';
import { Redirect, Route } from 'react-router-dom';

import { UserContext } from '../context/UserContext';

const MdiRoute = props => {
  const { isMdi } = useContext(UserContext);

  if (isMdi) {
    return <Route {...props} />;
  } else if (!isMdi) {
    return <Redirect to='/login' />;
  } else {
    return null;
  }
};

export default MdiRoute;
